module.exports = __webpack_public_path__ + "img/yellow-setting.6f381536.svg";